<template>
	<div class="modal-card large">
		<div class="modal-card-head">
			<div class="modal-card-title">Add aircraft to portfolio</div>
			<div class="modal-close-button" @click="$emit('close')"></div>
		</div>
		<div class="modal-card-body">
			<div class="mx-4 my-4">
				<div class="columns has-text-centered" id="addAircraft">
					<div class="column">
						<b-button class="is-secondary large-button" @click="createNew">Create new aircraft</b-button>
					</div>
					<div class="column">
						<b-button class="is-secondary large-button" @click="existingPortfolio">Add all from existing portfolio</b-button>
					</div>
					<div class="column">
						<b-button class="is-secondary large-button" @click="existingAircraft">Add existing aircraft</b-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		data() {
			return {
			}
		},
		methods: {
			createNew() {
				this.$emit("createNew");
				this.$parent.close();
			},
			existingPortfolio() {
				this.$emit("fromPortfolio");
				this.$parent.close();
			},
			existingAircraft() {
				this.$emit("existing");
				this.$parent.close();
			}
		}
	}
</script>

<style>
	.large-button {
		padding: 50px !important;
	}
</style>
